"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.GodRaysManager = void 0;
const THREE = __importStar(require("three"));
class GodRaysManager {
    // #endregion Properties (2)
    // #region Constructors (1)
    constructor(_renderingEngine) {
        this._renderingEngine = _renderingEngine;
        this._lightSource = null;
    }
    // #endregion Constructors (1)
    // #region Public Methods (3)
    removeLightSource() {
        this._godRaysEffect.lightSource = new THREE.Mesh();
    }
    setEffect(godRaysEffect) {
        this._godRaysEffect = godRaysEffect;
        this._godRaysEffect.lightSource = this._lightSource;
    }
    setLightSource(node) {
        this._lightSource = null;
        node.convertedObject[this._renderingEngine.id].traverse((o) => {
            if (o instanceof THREE.Mesh || o instanceof THREE.Points)
                this._lightSource = o;
        });
        if (this._lightSource) {
            if (Array.isArray(this._lightSource.material)) {
                (this._lightSource.material).forEach((m) => (m.transparent = true));
                (this._lightSource.material).forEach((m) => (m.depthWrite = false));
            }
            else {
                (this._lightSource.material).transparent = true;
                (this._lightSource.material).depthWrite = false;
            }
        }
        this._godRaysEffect.lightSource = this._lightSource;
    }
}
exports.GodRaysManager = GodRaysManager;
//# sourceMappingURL=GodRaysManager.js.map